/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export class QoEContainerFormatType {
    static UNKNOWN = 'Unknown';

    static DASHFMP4TS = 'DASH-FMP4 TS';

    static HLSFMP4TS = 'HLS-FMP4 TS';

    static DASHTS = 'DASH TS';

    static HLSTS = 'HLS TS';

    static MPEG = 'MPEG-2 TS';

    static SMOOTHTS = 'SMOOTH TS';
}
